import React, { useState } from "react";
import {
  LogoutRounded,
  SwapHorizRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { action, API, controller } from "../../../api/api";
import { useAppContext } from "context";
import { Dialog, Snackbar } from "../../../layout";
import SwitchUser from "./Switch/SwitchUser";
import { clearSessionScopedCache } from "hooks";
import { useTranslation } from "react-i18next";

const UserAction = () => {
  const { setAuthUser } = useAppContext();
  const { t } = useTranslation();
  const [showSwitchForm, setShowSwitchForm] = useState(false);
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  const handleLogout = () => {
    API(controller.Auth + action.Logout).get(() => {
      setAuthUser();
      navigate("/auth");
      clearSessionScopedCache();
      window.location.reload();
    });
    navigate("/auth");
  };

  const handleSwitch = () => {
    setShowSwitchForm(!showSwitchForm);
  };

  return (
    <>
      <div className="flex items-center justify-center gap-4 px-5 py-4 border-t">
        {/* Switch User */}
        <button
          onClick={handleSwitch}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded text-blue-600 !bg-blue-50 hover:!bg-blue-100 transition-colors text-[12px] font-medium"
        >
          <SwapHorizRounded sx={{ fontSize: 15 }} />
          {t("switchUser")}
        </button>

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded text-red-500 !bg-red-50 hover:!bg-red-100 transition-colors text-[12px] font-medium"
        >
          <LogoutRounded sx={{ fontSize: 15 }} />
          {t("logout")}
        </button>
      </div>

      {/* Switch User Form */}
      {showSwitchForm && (
        <Dialog show={showSwitchForm} onClose={false} maxWidth="md">
          <SwitchUser
            {...{
              setShowForm: setShowSwitchForm,
              showForm: showSwitchForm,
              setSnackbar,
            }}
          />
        </Dialog>
      )}
      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          vertical="bottom"
          horizontal="right"
        />
      )}
    </>
  );
};

export default UserAction;
